import { makeVar } from "@apollo/client";
import { Major, Interest } from "@/__generated__/types";
import { FilterContext } from "@/types/FilterContext";

export const majorsVar = makeVar<Major[] | null>(null);
export const interestsVar = makeVar<Interest[] | null>(null);
export const filterQueriesAreLoading = makeVar(false);
export const filterSidebarContext = makeVar(new FilterContext());
